import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useStore } from "../context/StoreContext";
import { money } from "../lib/api";
import { useSeo } from "../lib/seo";
import { CartLine, shippingFor } from "../components/shop/CartDrawer";
import { EmptyState } from "../components/shop/Common";

export default function CartPage() {
  const { items, subtotal } = useCart();
  const { settings } = useStore();
  useSeo({ title: "Your Cart", noindex: true });
  const ship = shippingFor(subtotal, settings);
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 sm:py-16" data-testid="cart-page">
      <h1 className="text-4xl sm:text-5xl font-extrabold text-navy">Your Cart</h1>
      {items.length === 0 ? (
        <div className="mt-10">
          <EmptyState title="Your cart is empty" text="Tell us where you're going and we'll help you pack." testid="cart-page-empty">
            <Link to="/destinations" className="rounded-full bg-sun px-6 py-3 font-bold text-navy">Find your destination</Link>
          </EmptyState>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-10 [&>*]:min-w-0">
          <div className="divide-y divide-border border-y border-border">{items.map((i) => <CartLine key={i.key} i={i} />)}</div>
          <aside className="rounded-[28px] bg-sand p-6 sm:p-8 h-fit lg:sticky lg:top-28" data-testid="order-summary">
            <h2 className="text-xl font-bold text-navy">Order summary</h2>
            <dl className="mt-6 space-y-3 text-navy">
              <div className="flex justify-between"><dt>Subtotal</dt><dd className="font-semibold" data-testid="cart-subtotal">{money(subtotal)}</dd></div>
              <div className="flex justify-between"><dt>Estimated shipping (U.S.)</dt><dd className="font-semibold" data-testid="cart-shipping">{ship === 0 ? "FREE" : money(ship)}</dd></div>
              <div className="flex justify-between text-sm text-navy/60"><dt>Taxes</dt><dd>Calculated at checkout</dd></div>
              <div className="flex justify-between border-t border-navy/10 pt-3 text-lg font-extrabold"><dt>Estimated total</dt><dd data-testid="cart-total">{money(subtotal + ship)}</dd></div>
            </dl>
            <p className="mt-6 text-sm text-navy/60">Have a discount code? Apply it at checkout.</p>
            <Link to="/checkout" className="mt-6 flex items-center justify-center gap-2 h-14 rounded-full bg-navy text-white font-bold" data-testid="checkout-button">
              <Lock className="w-4 h-4" /> Secure Checkout
            </Link>
            <p className="mt-3 text-xs text-navy/60 text-center">Printed on demand · ships in ~2–7 business days + transit</p>
          </aside>
        </div>
      )}
    </div>
  );
}
